import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { SettingsTabs, SettingsTab } from '../components/SettingsTabs'
import { UnitPreferencesTab } from '../components/UnitPreferencesTab'
import ApiKeysPanel from '../components/apiKeys/ApiKeysPanel'
import {
  NotificationSettings,
  OfflineCacheSettings,
  ChartSettings,
  GeneralSettings,
} from '../components/settings'

const isValidTab = (tab: string | undefined): tab is SettingsTab => {
  return (
    tab === 'units' ||
    tab === 'alerts' ||
    tab === 'cache' ||
    tab === 'charts' ||
    tab === 'preferences' ||
    tab === 'api-keys'
  )
}

export function SettingsPage() {
  const { tab } = useParams<{ tab?: string }>()
  const navigate = useNavigate()

  const activeTab: SettingsTab = isValidTab(tab) ? tab : 'units'

  useEffect(() => {
    if (!tab) {
      navigate('/settings/units', { replace: true })
    } else if (!isValidTab(tab)) {
      navigate('/settings/units', { replace: true })
    }
  }, [tab, navigate])

  const handleTabChange = (newTab: SettingsTab) => {
    navigate(`/settings/${newTab}`)
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'units':
        return <UnitPreferencesTab />
      case 'alerts':
        return <NotificationSettings />
      case 'cache':
        return <OfflineCacheSettings />
      case 'charts':
        return <ChartSettings />
      case 'preferences':
        return <GeneralSettings />
      case 'api-keys':
        return <ApiKeysPanel />
      default:
        return <UnitPreferencesTab />
    }
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="space-y-6">
        {/* Page Header */}
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
          <p className="mt-2 text-gray-600">Configure your account and preferences</p>
        </div>

        {/* Settings Card */}
        <div className="bg-white rounded-lg shadow">
          <div className="px-6 pt-6">
            <SettingsTabs activeTab={activeTab} onTabChange={handleTabChange} />
          </div>

          <div className="p-6">{renderTabContent()}</div>
        </div>
      </div>
    </div>
  )
}
